//OperationCompleted.tsx
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import theme from '../../style/theme';
import CustomMenu from '../../components/CustomMenu/CustomMenu';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';


/**
 * 操作完了ページコンポーネント
 * - 申請操作（承認・却下・差し戻しなど）の完了を表示する
 * - ブラウザバックによる誤操作を防止する
 */
export default function OperationCompleted() {

  const location = useLocation();
  const { action, activityName } = location.state || {};

  const displayName = activityName || action;//activityNameが存在しない場合は、設定したaction名称を表示する
  const navigate = useNavigate();
  var [nextUrl, setNextUrl] = useState<string>('');
  var [screenName, setScreenName] = useState<string>('');

  // ブラウザバックを防止し、ホームに遷移させる
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      alert("この画面はブラウザバックできません。");
      navigate("/");
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.pathname, navigate]);

  useEffect(() => {
    // （一覧画面への)画面遷移パス、表示する画面名の設定
    if (action === '却下' || action === '承認' || action === '差し戻し') {
      setNextUrl('/ReviewManagement');
      setScreenName('承認履歴画面');
    }
    else if (action === '取り下げ'|| action === '申請' || action === '再申請'|| action === '一時保存') {
      setNextUrl('/ProgressInquiry');
      setScreenName('申請履歴画面');
    } else if (action === '応答') {
      setNextUrl('/AwaitingReport');
      setScreenName('応答履歴画面');
    }
    else if (action === 'ワークフロー保存' || action === 'ワークフロー一時保存' ) {
      setNextUrl('/WorkFlowPage');
      setScreenName('ワークフロー新規作成・編集');
    } else {
      setNextUrl('/');
      setScreenName('');
    }
  }, [action]);

  return (
    <CustomMenu>

      {/* 内容エリア */}
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: "10%" }}>
        <TaskAltRoundedIcon color='success' sx={{ fontSize: 40, }} />
        {/* 操作完了に表示する文字 */}
        <Typography variant="h1" sx={{ ml: 2 }}>{`${displayName}完了です。`}</Typography>
      </Box>
      {/* リンク */}
      <Box sx={{ display: 'flex', justifyContent: 'center', m: 6, gap: 3 }}>
        {/* リンク先が設定されていない場合は、リンクを表示しない */}
        {nextUrl !== '/'&&(
        <Link
          // to={getListPagePath()}
          to={nextUrl}
          style={{
            textDecoration: 'underline',
            color: theme.palette.primary.main,
            fontWeight: 'bold',
          }}
        >
          {screenName}へ
        </Link>
        )}
        <Link
          to="/"
          style={{
            textDecoration: 'underline',
            color: theme.palette.primary.main,
            fontWeight: 'bold',
          }}
        >
          TOPへ
        </Link>
      </Box>
      {/* SVG図 */}
      <Box
        component="img"
        src="/OperationCompleted.svg"
        alt="Background icon"
        sx={{
          position: 'center',
          height: '200px',
          opacity: 0.9,
          zIndex: -1,
        }}
      />

    </CustomMenu>
  );

}